import { createContext, useContext, useEffect, useState } from "react";
import { getT } from "@/lib/i18n";

const LanguageContext = createContext({ lang: "fr", setLang: () => {}, t: getT("fr") });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "fr";
    // Priority: URL param ?lang → localStorage → default fr
    const urlLang = new URLSearchParams(window.location.search).get("lang");
    if (urlLang === "en" || urlLang === "fr") return urlLang;
    return localStorage.getItem("bicenter_lang") || "fr";
  });

  const setLang = (l) => {
    setLangState(l);
    if (typeof window !== "undefined") {
      localStorage.setItem("bicenter_lang", l);
      document.documentElement.lang = l;
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: getT(lang) }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
